import React, { useState } from 'react';
import '../styles/Personalitydevelopement.css';
import { useNavigate } from 'react-router-dom';
import axiosClient from '../api/axiosClient';

const categories = [
  {
    id: 'body',
    name: 'Body',
    accent: '#E25C4A',
    emoji: '💪',
    items: ['Fitness', 'Aging Better', 'Recovery & Healing', 'Eating Well', 'Wellness', 'Look Good', 'Better Sleep'],
  },
  {
    id: 'careerGrowth',
    name: 'Career Growth',
    accent: '#1E9E8C',
    emoji: '📈',
    items: ['Communication', 'Impact', 'Boost Creativity', 'Coaching', 'Career Growth', 'Teaching & Training', 'Problem Solving', 'Entrepreneurial Mindset', 'Money & Finance'],
  },
  {
    id: 'entrepreneurship',
    name: 'Entrepreneurship',
    accent: '#C9971F',
    emoji: '🚀',
    items: ['Running a Business', 'Career Growth', 'Vision', 'Purpose', 'Problem Solving', 'Passion', 'Impact', 'Entrepreneurial Mindset', 'Leadership', 'Money & Finance', 'Influence'],
  },
  {
    id: 'mind',
    name: 'Mind',
    accent: '#7C4FB3',
    emoji: '🧠',
    items: ['Quality of Life', 'Strength of Character', 'Habits & Discipline', 'Positive Optimism', 'Confidence', 'Happiness', 'Flow', 'Cognition', 'Speed Learning', 'Emotional Mastery', 'Resilience', 'Mind Management', 'Focus', 'Self-Love', 'Mindset'],
  },
  {
    id: 'interpersonalSkills',
    name: 'Interpersonal Skills',
    accent: '#D6406B',
    emoji: '🤝',
    items: [
      'Building Relationships',
      'Social Communication',
      'Networking',
      'Conflict Resolution',
      'Team Collaboration',
      'Empathy',
      'Active Listening',
      'Parenting',
      'Community Building'
    ],
  },
  {
    id: 'soul',
    name: 'Soul',
    accent: '#4E9A5C',
    emoji: '✨',
    items: ['Mind-Body Healing', 'Altered States of Consciousness', 'Oneness', 'Mind Power', 'Intuition', 'Meditation', 'Spirituality'],
  },
];


export default function GrowthAreasSelection() {
  const navigate = useNavigate();
  const [step, setStep] = useState(0);
  const [selections, setSelections] = useState(
    Object.fromEntries(categories.map((c) => [c.id, []]))
  );
  const [done, setDone] = useState(false);
  const [roadmap, setRoadmap] = useState("");
  const [loading, setLoading] = useState(false);

  const current = categories[step];
  const selected = selections[current.id];
  const isLast = step === categories.length - 1;
  const progressPct = ((step + (selected.length > 0 ? 1 : 0)) / categories.length) * 100;

  const toggle = (item) => {
    setSelections((prev) => ({
      ...prev,
      [current.id]: prev[current.id].includes(item)
        ? prev[current.id].filter((i) => i !== item)
        : [...prev[current.id], item],
    }));
  };


  // ------------api fetch---------------
const startPersonalityDevelopment = async () => {
  try {
    setLoading(true);

    let sessionId = localStorage.getItem("growthSessionId");

    if (!sessionId) {
      sessionId = `growth-user-${Date.now()}`;
      localStorage.setItem("growthSessionId", sessionId);
    }

    const dashboardData = JSON.parse(
      localStorage.getItem("dashboardData") || "{}"
    );

    const fullName = dashboardData.fullName;

    const selectedItems = Object.values(selections).flat();

    const response = await axiosClient.post(
      "/auth/api/users/api/mock-interview/start/personalDevelopment",
      selectedItems,
      {
        params: {
          sessionId,
          name: fullName,
        },
      }
    );

    setRoadmap(response.data);
    setDone(true);

  } catch (error) {
    console.log(error);
  } finally {
    setLoading(false);
  }
};
  // ------------api fetch---------------

  const goNext = async () => {
    if (selected.length === 0) return;

    if (isLast) {
      await startPersonalityDevelopment();
    } else {
      setStep((s) => s + 1);
    }
  };

  const goBack = () => step > 0 && setStep((s) => s - 1);

// ------------------loading screen-------------------
if (loading) {
  return (
    <div className="ga-loading-page">
      <div className="ga-loader-card">

        <div className="ga-spinner"></div>

        <h2>Creating Your Personalized Growth Plan</h2>

        <p>
          Our AI coach is analyzing your selected growth areas and preparing
          your 30-Day roadmap.
        </p>

        <div className="ga-loading-text">
          ⏳ This may take a few seconds...
        </div>

      </div>
    </div>
  );
}
// ------------------loading screen-------------------

  if (done) {
    const totalSelected = Object.values(selections).reduce((a, b) => a + b.length, 0);
    return (
      <div className="ga-page">
        <div className="ga-done-container">
          <div className="ga-done-check">
            <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="20 6 9 17 4 12" />
            </svg>
          </div>
          <h1 className="ga-done-title">You're all set</h1>
          <p className="ga-done-text">
            {totalSelected} growth areas selected across 6 categories. We'll tailor your journey around them.
          </p><button
            className="ga-done-btn"
            onClick={() =>
              navigate("/personalitydev", {
                state: {
                  roadmap,
                },
              })
            }
          >
            Continue
          </button>
         
          <button className="ga-done-edit" onClick={() => { setDone(false); setStep(0); }}>
            Edit selections
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="ga-page">
      <div className="ga-container">
        {/* Progress bar */}
        <div className="ga-progress-row">
          <span className="ga-progress-label">Step {step + 1} of {categories.length}</span>
          <span className="ga-progress-label">{Math.round(progressPct)}%</span>
        </div>
        <div className="ga-progress-track">
          <div
            className="ga-progress-fill"
            style={{ width: `${progressPct}%`, background: current.accent }}
          />
        </div>

        {/* Card */}
        <div className="ga-card">
          {/* Header */}
          <div className="ga-header">
            <div className="ga-icon-badge" style={{ background: `${current.accent}1a` }}>
              {current.emoji}
            </div>
            <div>
              <h1 className="ga-title">{current.name}</h1>
              <p className="ga-subtitle">Pick what you'd like to focus on</p>
            </div>
          </div>

          {/* Category dots */}
          <div className="ga-dots">
            {categories.map((cat, idx) => {
              const filled = selections[cat.id].length > 0;
              const clickable = filled || idx < step;
              return (
                <button
                  key={cat.id}
                  onClick={() => clickable && setStep(idx)}
                  disabled={!clickable}
                  title={cat.name}
                  className={`ga-dot ${clickable ? 'ga-dot--clickable' : 'ga-dot--disabled'}`}
                  style={{
                    background: idx === step ? current.accent : filled ? `${cat.accent}80` : '#ece8df',
                  }}
                />
              );
            })}
          </div>

          {/* Items */}
          <div className="ga-chips">
            {current.items.map((item) => {
              const isSelected = selected.includes(item);
              return (
                <button
                  key={item}
                  onClick={() => toggle(item)}
                  className={`ga-chip ${isSelected ? 'ga-chip--selected' : ''}`}
                  style={
                    isSelected
                      ? { background: current.accent, borderColor: current.accent }
                      : undefined
                  }
                >
                  {item}
                </button>
              );
            })}
          </div>

          {/* Selected count */}
          <div className="ga-count" style={{ color: selected.length > 0 ? current.accent : '#9a9aa6' }}>
            {selected.length > 0 ? `${selected.length} selected` : 'Select at least one to continue'}
          </div>

          {/* Nav buttons */}
          <div className="ga-nav">
            <button
              onClick={goBack}
              disabled={step === 0}
              className="ga-btn ga-btn--back"
            >
              <svg className="ga-chevron" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="15 18 9 12 15 6" />
              </svg>
              Back
            </button>
            <button
              onClick={goNext}
              disabled={selected.length === 0}
              className="ga-btn ga-btn--next"
              style={{ background: current.accent }}
            >
              {isLast ? 'Finish' : 'Next'}
              {!isLast && (
                <svg className="ga-chevron" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="9 18 15 12 9 6" />
                </svg>
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}